/// <reference path='../_all.ts' />

module navigation {
  'use strict';
  
  export class MenuNode {
    constructor(
      public Id: string,
      public Name: string,
      public Options: { [id: string]: string; },
      public Nodes: MenuNode[],
      public PageId : string,
      public IsCurrent: boolean,
      public RouteEntry : IRouteEntry,
      public Hide : boolean
      ) { }
  }
}